module.exports = __webpack_public_path__ + "static/media/img-6.11757b0d.jpeg";